import { gridRowsLoadingSelector } from '@mui/x-data-grid';
import {
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import { type MouseEvent } from 'react';
import { Icon } from '~/atoms';
import { Button } from '~/molecules/Button';

export const Pagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const isLoading = useGridSelector(apiRef, gridRowsLoadingSelector);

  const calculatedPageCount = Math.ceil(rowCount / pageSize);
  const firstRow = page * pageSize + 1;
  const lastRow = Math.min((page + 1) * pageSize, rowCount);

  const handlePageChange = (newPage: number) => (event: MouseEvent) => {
    event.preventDefault();

    apiRef.current.setPage(newPage);
  };

  const hasNextPage = page < calculatedPageCount - 1;
  const hasPreviousPage = page > 0;

  const label = rowCount ? `${firstRow}-${lastRow} von ${rowCount}` : '';

  return (
    <div
      className="flex items-center justify-end gap-2 px-2"
      data-testid="Datagrid-pagination"
    >
      <p className="text-sm whitespace-nowrap text-tiga-text-default select-none">
        {label}
      </p>
      <div className="flex items-center">
        <Button
          aria-label="Previous page"
          buttonStyle="link"
          disabled={!hasPreviousPage || isLoading}
          onClick={handlePageChange(page - 1)}
          className="rounded-none p-2 hover:text-tiga-action-lighter"
          icon={<Icon metaphor="chevronLeft" size="md" />}
        />
        <Button
          aria-label="Next page"
          buttonStyle="link"
          disabled={!hasNextPage || isLoading}
          onClick={handlePageChange(page + 1)}
          className="rounded-none p-2 hover:text-tiga-action-lighter"
          icon={<Icon metaphor="chevronRight" size="md" />}
        />
      </div>
    </div>
  );
};
